export default {"src":"/_next/static/media/xdai.394c24ba.svg","height":238,"width":238,"blurWidth":0,"blurHeight":0};